import { Box, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { maxRoasVectorPct } from './calc/roasSaturation';
import CopyRoasVectorButton from './CopyRoasVectorButton';

function HillMaxRoasSection({ hillModel }) {
  if (!hillModel?.k || !hillModel.maxRoasByMob?.length) {
    return null;
  }

  const maxRoasPct = maxRoasVectorPct(hillModel);
  const mobCount = hillModel.kMobCount ?? hillModel.kByMob?.length ?? 0;

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={2} flexWrap="wrap" gap={2}>
        <Box>
          <Text fontWeight="semibold" fontSize="sm">
            Hill max ROAS vector
          </Text>
          <Text fontSize="xs" color="gray.600" mt={0.5}>
            {`K $${Math.round(hillModel.k).toLocaleString()}`}
            {mobCount ? ` (mean of ${mobCount} MOBs)` : ''}
            {' · '}
            Max cumulative ROAS at $0 spend
          </Text>
        </Box>
        <CopyRoasVectorButton vectorPct={maxRoasPct} />
      </Flex>
      <Flex flexWrap="wrap" gap={2} mb={2} bg="white" p={3} borderRadius="lg">
        {maxRoasPct.map((value, index) => (
          <Box key={`hill-max-${index}`} className="roas-cell" textAlign="center">
            <Text className="annotation" mb={1}>
              M{index}
            </Text>
            <Text fontSize="sm" fontWeight="medium">
              {Number(value).toFixed(1)}%
            </Text>
          </Box>
        ))}
      </Flex>
      <Text fontSize="xs" className="annotation">
        Per-spend ROAS = max ROAS × K / (K + spend)
      </Text>
    </Box>
  );
}

HillMaxRoasSection.propTypes = {
  hillModel: PropTypes.shape({
    k: PropTypes.number,
    kMobCount: PropTypes.number,
    kByMob: PropTypes.array,
    maxRoasByMob: PropTypes.arrayOf(PropTypes.number),
  }),
};

export default HillMaxRoasSection;
